    <template>
  <div>
    <b-modal id="changePassword" size="sm" class="modal has-overflow">
       <template v-slot:modal-header>
        <div class="w-100">
          <h5 class="e-mtavr-17 e-bold modal-title">მომხმარებლის <strong class="e-text-eng-1 e-bold badge badge-secondary"> {{changePasswordParams.userName}} </strong> პაროლის ცვლილება</h5>
        </div>
      </template>
      <form autocomplete="off">
        <div class="row no-gutters row-bordered">
            <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
<b-form-group
              label="მომხმარებლის პაროლი"
              class="e-nusx-8 e-bold text-muted"
            >
             <b-input-group>
              <b-input placeholder="" type="password" v-model="changePasswordParams.password"/>
            </b-input-group>
            </b-form-group>
<b-form-group
              label="გაიმეორეთ პაროლი"
              class="e-nusx-8 e-bold text-muted"
            >
              <b-input type="password" v-model="changePasswordParams.rePassword" class="e-eng-font"/>
            </b-form-group>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
            <div class="callout callout-primary" v-if="standartPasswordGenerated">
              <h5 class="e-nusx-8 e-bold"><i><small>შენიშვნა</small></i></h5>
              <p class="e-nusx-8"><small>გაცნობებთ, რომ თქვენს მიერ მოხდა მომხმარებლისთვის სტანდარტული პაროლის გენერაცია. რეკომენდირებულია მომხმარებელმა შეცვალოს პაროლი პირველივე შესვლისას</small></p>
              <hr>
              <p class="e-nusx-8">დაგენერირებული პაროლი: <strong> {{changePassword.password}}</strong></p>
            </div>
          </div>
        </div>
      </form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            size="sm"
            variant="btn btn-primary"
            @click="save()"
            class="float-right e-mtavr-17"
            >შენახვა</b-button
          >
          <b-button
            size="sm"
            variant="btn btn-secondary"
            @click="close('changePassword')"
            class="float-right e-mtavr-17 mr-2"
            >გაუქმება</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import BaseService from '@/backend/vue-axios/axios.js'
export default {
  name: 'EditUserModal',
  props: ['changePasswordParams'],
  data () {
    return {
      usernameIsValid: undefined,
      usernameChecked: undefined,
      standartPasswordGenerated: false,
      showDetails: false,
      positions: [
        {
          value: null,
          text: 'აირჩიეთ პოზიცია'
        },
        {
          value: 1008,
          text: 'AML სისტემის ადმინისტრატორი'
        },
        {
          value: 1009,
          text: 'AML ჯგუფის უფროსი'
        },
        {
          value: 1010,
          text: 'AML ოფიცერი'
        },
        {
          value: 1011,
          text: 'AML მომხმარებელი'
        }
      ],
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      }
    }
  },
  methods: {
    close (id) {
      this.showDetails = false
      this.$bvModal.hide(id)
    },
    save () {
      BaseService.ChangePassword(this.header, this.changePasswordParams)
        .then(res => {
          if (res.data.success) {
            this.changePasswordParams = {}
            this.$bvModal.hide('changePassword')
          }
        })
    }
  }
}
</script>
